export default __webpack_public_path__ + "static/media/links-newsletter-j.592e6589.png";